import { Form } from "antd";
import React from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./AdnPhoneInput.css";

export const AdnPhoneInput = ({ name, value, defaultValue, disabled, rules, label = 'Phone' }) => {
    return (
        <Form.Item name={name} label={label} rules={rules}>
            <PhoneInput
                disabled={disabled}
                international
                value={value}
                defaultValue={defaultValue}
                defaultCountry="PT"
                placeholder="Insert phone number"
            />
        </Form.Item>
    );
};
